/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PartnerDetailsDto } from './PartnerDetailsDto';
export type CreateFollowupBookingDto = {
    /**
     * Follow-up plan UUID to book from
     */
    followup_plan_id: string;
    /**
     * Session mode
     */
    mode: CreateFollowupBookingDto.mode;
    /**
     * Selected availability slot IDs
     */
    selected_slot_ids: Array<string>;
    /**
     * Session type
     */
    session_type: CreateFollowupBookingDto.session_type;
    /**
     * Location UUID (for non-online modes)
     */
    location_id?: string;
    /**
     * Partner details (for duo sessions)
     */
    partner_details?: PartnerDetailsDto;
    /**
     * Currency code (derived from expert pricing when omitted)
     */
    currency?: string;
    /**
     * Idempotency key to safely retry without duplicates
     */
    idempotency_key: string;
    /**
     * Stripe SDK API version from mobile app
     */
    stripe_api_version: string;
    /**
     * UUID of a saved payment method to charge
     */
    payment_method_id?: string;
    /**
     * Setup future usage
     */
    setup_future_usage: CreateFollowupBookingDto.setup_future_usage;
};
export namespace CreateFollowupBookingDto {
    /**
     * Session mode
     */
    export enum mode {
        ONLINE = 'online',
        CLIENT_LOCATION = 'client_location',
        EXPERT_LOCATION = 'expert_location',
    }
    /**
     * Session type
     */
    export enum session_type {
        SINGLE = 'single',
        DUO = 'duo',
    }
    /**
     * Setup future usage
     */
    export enum setup_future_usage {
        OFF_SESSION = 'off_session',
        ON_SESSION = 'on_session',
    }
}

